"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpEvent = void 0;
var SignUpEvent;
(function (SignUpEvent) {
    SignUpEvent["SignUpPageVisit"] = "Sign Up Page Visit";
    SignUpEvent["AccountCreated"] = "Account Created";
    SignUpEvent["UserInvited"] = "User Invited";
    SignUpEvent["UserInvitationAccepted"] = "User Invitation Accepted";
    SignUpEvent["EmailVerified"] = "Email Verified";
    SignUpEvent["UserLogin"] = "User Login";
})(SignUpEvent || (exports.SignUpEvent = SignUpEvent = {}));
